import decamelizeLink from './decamelizeLink'
import httpLink from './httpLink'
import { ApolloClient } from 'apollo-client'
import { ApolloLink } from 'apollo-link'
import { InMemoryCache } from 'apollo-cache-inmemory'

const client = new ApolloClient({
  link: ApolloLink.from([decamelizeLink, httpLink]),
  cache: new InMemoryCache()
})

export default client



// WEBPACK FOOTER //
// ./src/config/apollo/client.js